<template>
	<SelectRoot :model-value="modelValue" @update:model-value="$emit('update:modelValue', $event)">
		<SelectTrigger class="input border-none hover:bg-base-100 w-20 text-center justify-center">
			<SelectValue />
		</SelectTrigger>

		<SelectPortal>
			<SelectContent class="z-50 w-20 bg-base py-2 shadow rounded border border-base-200 overflow-hidden" position="popper" :side-offset="4">
				<SelectViewport class="max-h-52 overflow-y-auto p-1">
					<SelectItem v-for="option in timeOptions" :key="option" :value="option" class="px-3 py-1 text-center rounded cursor-pointer outline-none data-[highlighted]:bg-base-100">
						<SelectItemText>{{ option }}</SelectItemText>
					</SelectItem>
				</SelectViewport>
			</SelectContent>
		</SelectPortal>
	</SelectRoot>
</template>

<script lang="ts">
import {
	SelectRoot,
	SelectTrigger,
	SelectValue,
	SelectPortal,
	SelectContent,
	SelectViewport,
	SelectItem,
	SelectItemText,
} from 'reka-ui';
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/vue/24/outline';

export default {
	name: 'TimePicker',

	components: {
		SelectRoot, SelectTrigger, SelectValue, SelectPortal, SelectContent,
		SelectViewport, SelectItem, SelectItemText,
		ChevronUpIcon, ChevronDownIcon
	},

	props: {
		modelValue: {
			type: String,   // hh:mm
			validator(value) {
				const regex = new RegExp(/^([01]?[0-9]|2[0-3]):?([0-5]\d)$/);
				return regex.test(value);
			}
		},
		interval: {
			type: Number,
			default: 5,
			validator(value) {
				return [1, 5, 10, 15, 20, 30, 60].includes(value);
			}
		},
	},

	emits: ['update:modelValue'],

	computed: {
		timeOptions() {
			const options = [];
			for (let h = 0; h < 24; h++) {
				for (let m = 0; m < 60; m += this.interval) {
					options.push(h.toString().padStart(2, '0') + ':' + m.toString().padStart(2, '0'));
				}
			}
			return options;
		},
	},
};
</script>
